// extracted by mini-css-extract-plugin
export default {"bodySection":"Where_bodySection__bymSE"};